// client/src/core/game/GameUI.js
window.GameUI = {
    typewriterInterval: null,
    typewriterTimeout: null,

    /**
     * Soruyu ekrana yazdırır (daktilo efekti ile).
     * @param {Object} q - Soru objesi
     * @param {Function} onComplete - Yazma bitince çalışacak callback
     * @param {Function} onAnswerData - Cevap verildiğinde çalışacak fonksiyon (closure için)
     * @param {Boolean} skipSound - Ses çalınmasını engeller (sürebitti çakışmasını önlemek için)
     */
    displayQuestion: function (q, onComplete, onAnswerClick) {
        const questionTextEl = document.getElementById('question-text');
        const optionsContainer = document.getElementById('options-container');

        // UI Temizle
        // questionTextEl.innerText = ''; // ARTIK setupTypewriter KULLANILIYOR
        optionsContainer.innerHTML = '';
        optionsContainer.style.pointerEvents = 'none';

        // [A11Y] Erişilebilirlik için Metin Hazırlığı
        let targetVisualEl = questionTextEl;
        if (window.AccessibilityManager) {
            targetVisualEl = window.AccessibilityManager.setupTypewriter(questionTextEl, q.text);
        } else {
            questionTextEl.innerText = '';
        }

        // [FIX] Apply Text Color Preference
        questionTextEl.style.color = "var(--question-text-color, #fff)";

        // Daktilo Efekti
        let i = 0;
        this.clearTypewriter();

        const typeWriter = () => {
            if (i < q.text.length) {
                const char = q.text.charAt(i);
                targetVisualEl.textContent += char; // [A11Y] Visual elemente yaz
                i++;

                let delay = 5; // [OPTIMIZED] Much faster animation
                if (['.', ',', '!', '?', ':'].includes(char)) {
                    delay = 20; // Punctuation pause
                } else if (char === ' ') {
                    delay = 5;
                }

                this.typewriterTimeout = setTimeout(typeWriter, delay);
            } else {
                // Yazma bitti, şıkları göster
                this.renderOptions(q, optionsContainer, onAnswerClick);
                if (onComplete) onComplete();
            }
        };

        typeWriter();

        // Skor ve Sayaç güncelle
        this.updateScoreDisplay();
        this.updateQuestionCount();

        // Zamanlayıcıyı başlangıç durumuna getir
        if (window.state && window.state.isTimedMode) {
            this.updateTimer(window.state.timePerQuestion || 15);
        } else {
            this.updateTimer("∞");
        }
    },

    renderOptions: function (q, container, onAnswerClick) {
        container.style.pointerEvents = 'all';
        const letters = ['A', 'B', 'C', 'D'];

        // Animasyon için delay sayacı
        let delay = 0;

        q.options.forEach((opt, index) => {
            const btn = document.createElement('button');
            btn.className = 'option-btn';
            btn.style.animationDelay = `${delay}ms`; // Sıralı geliş efekti

            // [A11Y] Şıklar için erişilebilir etiket
            btn.setAttribute('aria-label', `${letters[index]} şıkkı: ${opt}`);

            delay += 100;

            const badge = document.createElement('span');
            badge.className = 'opt-badge';
            badge.innerText = letters[index];
            badge.setAttribute('aria-hidden', 'true'); // Tekrar okumayı engelle

            const textSpan = document.createElement('span');
            textSpan.className = 'opt-text';
            textSpan.innerText = opt;
            textSpan.setAttribute('aria-hidden', 'true'); // Tekrar okumayı engelle

            btn.appendChild(badge);
            btn.appendChild(textSpan);

            btn.onclick = () => onAnswerClick(index);
            container.appendChild(btn);
        });
    },

    handleAnswerVisuals: function (selectedIndex, correctIndex, skipSound = false) {
        const optionsContainer = document.getElementById('options-container');
        const buttons = optionsContainer.querySelectorAll('.option-btn');

        optionsContainer.style.pointerEvents = 'none';

        const isCorrect = selectedIndex === correctIndex;

        // [A11Y] Sesli Geri Bildirim
        if (window.AccessibilityManager) {
            const letters = ['A', 'B', 'C', 'D'];
            const message = isCorrect
                ? "Doğru Cevap!"
                : `Yanlış Cevap. Doğru cevap: ${letters[correctIndex]} şıkkıydı.`;
            window.AccessibilityManager.announce(message, 'assertive');
        }

        // Ses Efektleri
        if (!skipSound) {
            if (isCorrect) {
                window.audio.playSound('correct');
            } else {
                window.audio.playSound('wrong');
            }
        }

        // Renk Değişimleri
        buttons.forEach((btn, index) => {
            if (index === correctIndex) {
                btn.classList.add('correct'); // Doğru cevap yeşil
            } else if (index === selectedIndex && !isCorrect) {
                btn.classList.add('wrong'); // Yanlış cevap kırmızı
            }
        });
    },

    updateScoreDisplay: function () {
        const scoreEl = document.getElementById('score-display');
        if (scoreEl && window.state) {
            // Animasyonlu güncelleme
            const oldScore = parseInt(scoreEl.innerText) || 0;
            const newScore = window.state.score;

            scoreEl.innerText = newScore;

            if (newScore > oldScore) {
                scoreEl.style.transform = "scale(1.5)";
                scoreEl.style.color = "#00ff00"; // Yeşil yanıp söner
                setTimeout(() => {
                    scoreEl.style.transform = "scale(1)";
                    scoreEl.style.color = "#fff";
                }, 300);
            }
        }
    },

    // YENİ: Soru Sayacı Güncelleme
    updateQuestionCount: function () {
        const countEl = document.getElementById('question-count-display');
        if (countEl && window.state) {
            const current = window.state.currentQuestionIndex + 1;
            const total = window.state.activeQuestions ? window.state.activeQuestions.length : 10;
            countEl.innerText = `${current} / ${total}`;
        }
    },

    updateTimer: function (timeLeft) {
        const timeEl = document.getElementById('time-display');
        if (timeEl) {
            // Eğer infinity sembolü gönderildiyse direkt yaz, yoksa sayıyı yaz
            timeEl.innerText = timeLeft;

            // Süre azaldıkça renk değiştir (Sadece sayıysa)
            if (typeof timeLeft === 'number') {
                if (timeLeft <= 5) {
                    timeEl.style.color = '#ff5252'; // Kırmızı
                    timeEl.style.textShadow = '0 0 10px #ff0000';
                } else {
                    timeEl.style.color = '#fff';
                    timeEl.style.textShadow = 'none';
                }
            } else {
                // Sonsuzluk için stil
                timeEl.style.color = '#00e5ff'; // Turkuaz
                timeEl.style.fontSize = '1.5em';
                timeEl.style.textShadow = '0 0 10px #00e5ff';
            }
        }
    },

    showEndGameScreen: function (score, correct, wrong, category) {
        // [FIX] Önce ekranı oluştur ki DOM elementleri oluşsun
        window.ui.showScreen('result-screen');

        const finalScoreEl = document.getElementById('final-score');
        const correctCountEl = document.getElementById('correct-count');
        const wrongCountEl = document.getElementById('wrong-count');

        if (finalScoreEl) finalScoreEl.innerText = score;
        if (correctCountEl) correctCountEl.innerText = correct;
        if (wrongCountEl) wrongCountEl.innerText = wrong;

        // BAŞARI YÜZDESİ HESAPLAMA
        const total = correct + wrong;
        const percentage = total > 0 ? (correct / total) * 100 : 0;
        const msgEl = document.getElementById('result-message');

        // DİNAMİK MESAJLAR
        let message = "";
        let color = "#fff";

        if (percentage >= 100) {
            message = "🔥 MÜKEMMEL! GADDAR SENİNLE GURUR DUYUYOR! 🔥";
            color = "#ffd700"; // Altın
        } else if (percentage >= 80) {
            message = "👏 Harikasın! Neredeyse kusursuzsun.";
            color = "#00e676"; // Yeşil
        } else if (percentage >= 50) {
            message = "🧐 Fena değil, ama daha iyisini yapabilirsin.";
            color = "#ffeb3b"; // Sarı
        } else if (percentage >= 30) {
            message = "😬 Biraz daha çalışman lazım, Gaddar beğenmedi.";
            color = "#ff9800"; // Turuncu
        } else {
            message = "🤦‍♂️ Bu ne hal? Gaddar seni görmek istemiyor!";
            color = "#ff5252"; // Kırmızı
        }

        if (msgEl) {
            msgEl.innerText = message;
            msgEl.style.color = color;
            msgEl.style.fontWeight = "bold";
            msgEl.style.textShadow = "0 2px 10px rgba(0,0,0,0.5)";
        }

        console.log("Game Ended. Category:", category);

        const restartBtn = document.getElementById('restart-btn');
        if (restartBtn) {
            if (category === 'custom_wheel') {
                restartBtn.innerText = "ÇARKA DÖN";
            } else if (category === 'mythology') {
                restartBtn.innerText = "MİTOLOJİYE DÖN";
            } else if (category === 'custom_gaddar' || category === 'custom_week' || category === 'history_today') {
                restartBtn.innerText = "KATEGORİLERE DÖN";
            } else {
                restartBtn.innerText = "YENİDEN DENE";
            }
        }
    },

    clearTypewriter: function () {
        if (this.typewriterInterval) clearInterval(this.typewriterInterval);
        if (this.typewriterTimeout) clearTimeout(this.typewriterTimeout);
    },

    /**
     * Mobile Shake-to-Read (TTS)
     */
    readQuestionAloud: function () {
        const questionEl = document.getElementById('question-text');
        if (!questionEl || !questionEl.innerText.trim()) return;

        // Ensure we are in a game
        const gameScreen = document.getElementById('game-screen');
        const onlineGameScreen = document.getElementById('online-game-screen');
        const isActive = (gameScreen && gameScreen.classList.contains('active')) ||
            (onlineGameScreen && onlineGameScreen.classList.contains('active'));

        if (!isActive) return;

        if (window.speechSynthesis) {
            // Cancel existing speech
            window.speechSynthesis.cancel();

            let textToRead = questionEl.innerText;

            // Include options if they exist
            const optionsContainer = document.getElementById('options-container');
            if (optionsContainer) {
                const options = optionsContainer.querySelectorAll('.option-btn');
                const letters = ['A', 'B', 'C', 'D'];
                options.forEach((opt, idx) => {
                    const optText = opt.querySelector('.opt-text')?.innerText || opt.innerText;
                    textToRead += `. ${letters[idx]} şıkkı, ${optText}`;
                });
            }

            const utterance = new SpeechSynthesisUtterance(textToRead);
            utterance.lang = 'tr-TR';
            utterance.rate = 1.0;
            window.speechSynthesis.speak(utterance);
        }
    }
};

// --- Mobile Shake Detection Logic ---
(function () {
    let lastUpdate = 0;
    let lastX, lastY, lastZ;
    const threshold = 15; // Shake sensitivity

    window.addEventListener('devicemotion', (event) => {
        const acceleration = event.accelerationIncludingGravity;
        if (!acceleration) return;

        const curTime = Date.now();
        if ((curTime - lastUpdate) > 100) {
            const diffTime = curTime - lastUpdate;
            lastUpdate = curTime;

            const x = acceleration.x;
            const y = acceleration.y;
            const z = acceleration.z;

            const speed = Math.abs(x + y + z - lastX - lastY - lastZ) / diffTime * 10000;

            if (speed > threshold * 50) { // Adjusting sensitivity for this algorithm
                if (window.GameUI && window.GameUI.readQuestionAloud) {
                    window.GameUI.readQuestionAloud();
                }
            }

            lastX = x;
            lastY = y;
            lastZ = z;
        }
    }, false);

    // Fallback or explicit button for permission might be needed in iOS 13+ 
    // but we'll stick to event for now.
})();
